import NewsHome from '@/pages/news/NewsHome'
import CreateNews from '@/pages/news/CreateNews'
import EditNews from '@/pages/news/EditNews'

const routes = [
  {
    path: '/news',
    name: 'NewsHome',
    component: NewsHome,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  },
  {
    path: '/create-news',
    name: 'CreateNews',
    component: CreateNews,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  },
  {
    path: '/edit-news/:id',
    name: 'EditNews',
    component: EditNews,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    },
    props: true
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/news.js